<template id="child">

  <div v-if="showModal" :style="cssProps">
      <div>
    <div class="modal d-flex flex-column">
      <h1>Tips</h1>
        <!-- begin -->
    <div class="d-flex flex-row row-btnTips">
        <button v-for="item in items" class="d-flex flex-column align-items-center justify-content-around"  :class="{active:item.id == selected}" @click="selected = item.id">
            <span>{{item.id}}</span>
            <span>{{item.id}}</span>
           
        </button>
         <!-- <button class="d-flex flex-column align-items-center justify-content-around" :class="check?'active':'disable'" @click="Check">
            <span>15</span>
            <span>$1.43</span>
        </button>
         <button class="d-flex flex-column align-items-center justify-content-around" :class="check?'active':'disable'" @click="Check">  
            <span>20</span>
            <span>$1.84</span>
        </button>
         <button class="d-flex flex-column align-items-center justify-content-around" :class="check?'active':'disable'" @click="Check">
            <span>25</span>
            <span>$2.06</span>
        </button>
         <button class="d-flex flex-column align-items-center justify-content-around" :class="check?'active':'disable'" @click="Check">
            <span>30</span>
            <span>$2.59</span>
        </button> -->
    </div>
      <!-- end -->
      <div class="d-flex justify-content-center btn-cancel" @click="hide">
      <button >
        <span>Cancel</span>
      </button>
      </div>
    </div>
    </div>
    
      
    <div class="modal-overlay"></div>
  </div>
  
</template>
<script>
var items = []
for (var i = 1; i <= 5; i++) {
  items.push({
    id: i
  })
}
import { mapState } from "vuex";
export default {
  template: "#child",
  data() {
    return {
      showModal: false,
       items,
    selected: undefined,
    selected2: []
    };
  },
  computed: {
    ...mapState(['info']),
		cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    }
	},
  methods: {
      Check(){

            this.check = !this.check;
            console.log(this.check)
        
      },
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
      
    },
   
  },
  created(){
  }
};
</script>
<style scoped>
.row-btnTips{
    padding-top: 48px;
}
.active {
    background-color: rgba(0,0,0,0.6) !important;
    opacity: 1 !important;
    color: #ffffff;
}
.active span:first-child{

	color: #FFFFFF;
	font-family: Poppins;
	font-size: 20px;
	font-weight: bold;
	line-height: 30px;
    opacity: 1;
	
}
.active span:first-child::after{
    opacity: 1!important;
    color:#FFFFFF!important;
}
.active span:nth-child(2){
   
	color: #FFFFFF !important;
	font-family: Poppins !important;
	font-size: 12px !important;
	font-weight: 500 !important;
	line-height: 18px !important;
    opacity: 1 !important;

}

.row-btnTips button{
    padding: 20px;
    margin-left: 2px;
	height: 74px;
	width: 64px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;

}
.row-btnTips button span{
   
	height: 28px;
	width: 64px;
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 20px;
	font-weight: 300;
	line-height: 30px;
	text-align: center;
}
.row-btnTips button span:first-child::after{
    content: "%";
    position: relative;
    top:-6px;

	height: 17px;
	width: 9px;
	opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;

}
.row-btnTips button span:nth-child(2){
   
	height: 17px;
	width: 64px;
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	text-align: center;

}

button{
  border: none;
  outline: none;
  background: none;
}
.btn-cancel button
{
 margin-top: 40px;
	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;
}
.btn-cancel span{
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}


.modal {
   position: fixed;;
  left:0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  overflow-y:auto;
  padding: 48px;
  box-sizing: border-box;

  z-index: 5;

  height: 349px;
 width: 426px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
}
.modal h1 {
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 24px;
	font-weight: 800;
	line-height: 35px;
	text-align: center;

}

.modal-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 1;
}
input
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}

/* .active {
  background-color: var(--main-color) !important;
}
.active i {
  color: #ffffff !important;
}
.active span {
  color: #ffffff !important;
} */
@media screen and (max-width: 600px)
{
  .modal{
    width: 100%;
    height: 80%;
    
  }
  .column-input
  {
    height: 80%;
  }
  .column-input input
  {
    width: 100%;
  }
  .button
    {
        flex-direction: column-reverse !important;
        justify-content: center !important;
        align-items: center !important;

    }
    .button button:first-child
    {
        width: 100%;
        margin-top: 10px;
    }
    .button button:last-child
    {
        width: 100%;
    }
  
}
</style>



// WEBPACK FOOTER //
// src/components/steps/modals/tips.vue